<template>
  <UserDashboard />
</template>

<script>
import UserDashboard from "@/components/Ondemand/Dashboard/Dashboard.vue";
export default {
  components: {
    UserDashboard,
  },
  computed: {
    userType() {
      return this.$store.getters.userType;
    },
  },
  methods: {
  },
  mounted() {
    let userType = this.$store.getters.userType;
    if (userType != "ondemand") {
      this.$router.push("/3pl/dashboard");
    }
    this.$_addTwakTo();
    this.$_removeTwakTo('display: block !important');
  },
  beforeDestroy() {
    this.$_removeTwakTo('display: none !important');
  }
};
</script>

<style></style>
